export default __webpack_public_path__ + "static/media/apple.487f99c3.svg";